import CreatePost from './CreatePost';

export default CreatePost;